import { getPlatform } from "../platform/platformRef";

/** Hands an absolute URL to the system browser: the desktop host's external open, else
 * the platform's own `url` open, else a new window (the iOS shell hands that to Safari). */
export function openInBrowser(url: string): void {
    const platform = getPlatform();
    if (platform.files?.openExternal) {
        void platform.files.openExternal(url).catch(() => undefined);
        return;
    }
    if (platform.open({ kind: "url", url }) === "fallback")
        window.open(url, "_blank", "noopener,noreferrer");
}
